console.log("dev by https://felixjuhel.com/");

document.querySelector(".menu-mobile .menu-hamburger").onclick = function() {
  if (document.querySelector(".menu-mobile .menu-mobile-liste").hasAttribute("open")) {
      document.querySelector(".menu-mobile .menu-mobile-liste").removeAttribute("open");
  }else{
      document.querySelector(".menu-mobile .menu-mobile-liste").setAttribute("open", "");
  }
};


document.querySelector(".menu-mobile .menu-mobile-liste .croix-menu").onclick = function() {
  if (document.querySelector(".menu-mobile .menu-mobile-liste").hasAttribute("open")) {
    document.querySelector(".menu-mobile .menu-mobile-liste").removeAttribute("open");
  }else{
    document.querySelector(".menu-mobile .menu-mobile-liste").setAttribute("open", "");
  }
};


var soundBtn = document.querySelectorAll('.banniere-principale .sound');
for (var i = 0; i < soundBtn.length; i++) {
  soundBtn[i].addEventListener('click', function() {
    var soundBtnTarget = this;
    var video = soundBtnTarget.parentElement.parentElement.querySelector("video");
    if ( soundBtnTarget.classList.contains("active") === true ){
      soundBtnTarget.classList.remove("active");
      video.muted = true;
    }else{
      soundBtnTarget.classList.add("active");
      video.muted = false;
    }
  });
}

function updateImageSources() {
  var width_screen = window.innerWidth;
  if (width_screen <= 600) {
    document.querySelectorAll('img').forEach(function(img) {
      if (img.hasAttribute("src-mobile")) {
        img.setAttribute("src", img.getAttribute("src-mobile"));
      }
    });
  }else{
    document.querySelectorAll('img').forEach(function(img) {
      if (img.hasAttribute("src-desktop")) {
        img.setAttribute("src", img.getAttribute("src-desktop"));
      }
    });
  }
}
updateImageSources();

window.addEventListener('resize', function() {
  updateImageSources();
});


if (!!document.querySelector(".section.banniere-principale") === true){
  if ( document.querySelector(".section.banniere-principale").classList.contains("active") === true && !!document.querySelector(".animation-logo img") === true ){
    var src = document.querySelector(".animation-logo img").getAttribute("src");
    document.querySelector(".animation-logo img").setAttribute('src', src + '?' + Math.random());
    document.querySelector(".animation-logo img").setAttribute('src', src);
    document.querySelectorAll(".section.animation-logo .opacity").forEach(function(opacity) {
      opacity.style.opacity = "0";
    });
  }
}


if (!!document.querySelector(".langues .desktop-localization-wrapper") === true){
  var activeLangue = document.querySelector("#HeaderLanguageList .link.disclosure__link--active").getAttribute("lang");
  var autreLangue = document.querySelector("#HeaderLanguageList .link:not(.disclosure__link--active)").getAttribute("lang");
  document.querySelector("header#header-website nav.menu-right>ul .langues").insertAdjacentHTML("afterbegin", '<span class="activeLangue" lang="'+ activeLangue +'">'+ activeLangue +'</span><span class="autreLangue" lang="'+ autreLangue +'">'+ autreLangue +'</span>');
  document.querySelector("header#header-website .menu-mobile-liste .menu-principal-mobile").insertAdjacentHTML("beforeend", '<li class="mobile-langues"><span class="activeLangue" lang="'+ activeLangue +'">'+ activeLangue +'</span><span class="autreLangue" lang="'+ autreLangue +'">'+ autreLangue +'</span></li>');

  document.querySelector("header#header-website nav.menu-right>ul .langues span.autreLangue").onclick = function() {
    document.querySelector("#HeaderLanguageList .link:not(.disclosure__link--active)").click();
  };

  document.querySelector("header#header-website .menu-mobile-liste .menu-principal-mobile li.mobile-langues span.autreLangue").onclick = function() {
    document.querySelector("#HeaderLanguageList .link:not(.disclosure__link--active)").click();
  };
}



if (!!document.querySelector(".product .content .informations .liste-infos li") === true){
  document.querySelector(".product .content .informations .liste-infos li").classList.add("active");
  document.querySelector(".product .content .informations>div:nth-child(2)").classList.add("active");
  var listeInfos = document.querySelectorAll('.product .content .informations .liste-infos li');
  for (var i = 0; i < listeInfos.length; i++) {
  	listeInfos[i].addEventListener('click', function(event) {
      var target = event.target;
      if ( target.classList.contains("active") === false ){
        if (!!document.querySelector(".product .content .informations .liste-infos li.active") === true){
          document.querySelector('.product .content .informations .liste-infos li.active').classList.remove("active");
          document.querySelector('.product .content .informations div.active').classList.remove("active");
        }
        target.classList.add("active");
        document.querySelector('.product .content .informations div[value="'+ target.getAttribute("value") +'"]').classList.add("active");
      }else{
        target.classList.remove("active");
      }
  	});
  }
}


var miniaturesAPropos = document.querySelectorAll('.infos-pop-up .all-details .miniature img');
for (var i = 0; i < miniaturesAPropos.length; i++) {
  miniaturesAPropos[i].addEventListener('click', function(event) {
    var img = event.target;
    var number = img.parentElement.getAttribute("number");
    img.parentElement.parentElement.parentElement.querySelector('.section-details[number="'+ number +'"]').classList.add("active");
    document.head.insertAdjacentHTML('beforeend', '<style id="style-pop-up">#fullpage{z-index: 11000;}</style>');
  });
}

var croixAPropos = document.querySelectorAll('.infos-pop-up .all-details .section-details>div figcaption .croix-pop-up');
for (var i = 0; i < croixAPropos.length; i++) {
  croixAPropos[i].addEventListener('click', function(event) {
    if ( this.parentElement.parentElement.parentElement.classList.contains("active") === true ){
      this.parentElement.parentElement.parentElement.classList.remove("active");
    }else{
      this.parentElement.parentElement.parentElement.parentElement.parentElement.classList.remove("active");
    }
    document.querySelector('#style-pop-up').remove();
  });
}

var croixAPropos2 = document.querySelectorAll('.infos-pop-up .all-details .section-details.image-full>div .croix-pop-up');
for (var i = 0; i < croixAPropos2.length; i++) {
  croixAPropos2[i].addEventListener('click', function(event) {
    this.parentElement.parentElement.classList.remove("active");
    document.querySelector('#style-pop-up').remove();
  });
}

var background = document.querySelectorAll('.all-details .section-details');
for (var i = 0; i < background.length; i++) {
  background[i].addEventListener('click', function(event) {
    if ( event.target.classList.contains("section-details") === true ){
      event.target.classList.remove("active");
      document.querySelector('#style-pop-up').remove();
    }
  });
}

var popUpPetiteHistoire = document.querySelectorAll('.product .content .en-savoir-plus li>span[histoire]');
for (var i = 0; i < popUpPetiteHistoire.length; i++) {
  popUpPetiteHistoire[i].addEventListener('click', function(event) {
    this.parentElement.querySelector('.pop-up-histoire').classList.add("active");
    document.head.insertAdjacentHTML('beforeend', '<style id="style-pop-up">#fullpage{z-index: 11000;}</style>');
  });
}

var croixPetiteHistoire = document.querySelectorAll('.pop-up-histoire>div .croix-pop-up');
for (var i = 0; i < croixPetiteHistoire.length; i++) {
  croixPetiteHistoire[i].addEventListener('click', function(event) {
    this.parentElement.parentElement.parentElement.classList.remove("active");
    document.querySelector('#style-pop-up').remove();
  });
}



if (!!document.querySelector(".section.collections") === true){
  let changePhotosInitialized = false;
  window.addEventListener('scroll',(event) => {
    var width_screen = window.innerWidth;
    if (width_screen <= 600) {
      var top_page = window.scrollY;
      var top_episodes = document.querySelector(".section.collections").offsetTop;
      if (top_page > top_episodes && !changePhotosInitialized) { 
        function changePhotos() {
          document.querySelectorAll('.section.collections .fp-overflow .tous-les-episodes .episode').forEach(function(episode, i) {
            setTimeout(function () {
                episode.querySelector("figure img:first-child").style.cssText = "opacity: 0;";
                setTimeout(function () {
                    episode.querySelector("figure img:first-child").style.cssText = "opacity: 1;";
                }, 20000);
            }, (i * 2000));
          });
        }
        changePhotos();
        setInterval(changePhotos, 30000);
        changePhotosInitialized = true;
      }
    }
  });
}



if (!!document.querySelector(".product .content .informations .liste-infos") === true){
  var width_screen = window.innerWidth;
  if (width_screen <= 600) {
    document.querySelectorAll('.product .content .informations>div').forEach(function(div) {
      var nom = div.getAttribute("value");
      var element = div.outerHTML;
      document.querySelector('.product .content .informations .liste-infos li[value="'+ nom +'"]').insertAdjacentHTML("afterend", element);
      div.remove();
    });
  }
}


var liMenu = document.querySelectorAll('header#header-website .menu-mobile .menu-principal-mobile li a[href="#"]');
for (var i = 0; i < liMenu.length; i++) {
  liMenu[i].addEventListener('click', function(event) {
    if ( event.target.classList.contains("active") === true ){
      event.target.classList.remove("active");
    }else{
      event.target.classList.add("active");
    }
  });
}


setTimeout(function () {
  document.querySelector('#pandectes-banner').onclick = function(e) {
    if ( e.target.getAttribute("id") == "pandectes-banner" ){
      document.querySelector('#pandectes-banner a[aria-label="deny cookies"]').click();
    }
  };
}, 1000);



window.addEventListener("load", (event) => {  
  if (!!document.querySelector(".splide") === true){
    document.querySelectorAll('.splide').forEach(function(splide) {
      var nbSplide = splide.querySelectorAll(".splide__pagination li").length;
      if ( nbSplide == 1 ){
        splide.querySelector(".splide__arrows").style.cssText = "display: none;";
      }
    });
  }
});



if (!!document.querySelector(".pop-up-vacances") === true && !!document.querySelector(".pop-up-vacances .croix-pop-up") === true) {
  if (document.cookie.indexOf("pop-up-vacances") !== -1) {
    document.querySelector(".pop-up-vacances").remove();
  } else {
    var currentDate = new Date();
    if (currentDate >= date1 && currentDate <= date2) {
      setTimeout(function () {
        document.querySelector(".pop-up-vacances").classList.add("active");
      }, 5000);
  
      document.querySelector(".pop-up-vacances .croix-pop-up").onclick = function () {
        var expirationDate = new Date();
        expirationDate.setDate(expirationDate.getDate() + 1);
        var expires = expirationDate.toUTCString();
        document.cookie = "pop-up-vacances=true; expires=" + expires + "; path=/";
        setTimeout(function () {
          document.querySelector(".pop-up-vacances").remove();
        }, 100);
      };
    }
  }
  document.head.insertAdjacentHTML('beforeend', '<style>form#slidecart-checkout-form::before{content: "'+ textBefore +'";}</style>');
} else if (!!document.querySelector(".pop-up-vacances") === true){
  document.head.insertAdjacentHTML('beforeend', '<style>form#slidecart-checkout-form::before{content: "'+ textBefore +'";}</style>');
  document.querySelector(".pop-up-vacances").remove();
}


// Ouverture automatique d'un pop-up via ?ouvrir=...
(function () {
  var params = new URLSearchParams(window.location.search);
  var ouvrir = params.get("ouvrir");
  if (!ouvrir || !document.querySelector(".infos-pop-up")) return;

  function normaliser(texte) {
    return texte
      .toLowerCase()
      .normalize("NFD").replace(/[\u0300-\u036f]/g, "") // retire les accents
      .replace(/[-_+]/g, " ")                          // tirets = espaces
      .replace(/\s+/g, " ")
      .trim();
  }

  var cible = normaliser(ouvrir);

  document.querySelectorAll(".infos-pop-up .all-details .miniature h3").forEach(function (h3) {
    if (normaliser(h3.textContent) === cible) {
      var img = h3.parentElement.querySelector("img");
      if (img) img.click();
    }
  });
})();